interface Step {
  number: number;
  label: string;
  icon: string;
}

interface StepIndicatorProps {
  currentStep: number;
  steps: Step[];
}

const StepIndicator = ({ currentStep, steps }: StepIndicatorProps) => (
  <div className="w-full" dir="rtl">
    <div className="flex items-center justify-between relative">
      {/* Progress Line */}
      <div className="absolute top-5 right-5 left-5 h-0.5 bg-stone-200 z-0">
        <div
          className="h-full bg-emerald-500 transition-all duration-500"
          style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
        />
      </div>

      {steps.map((step) => {
        const isDone = currentStep > step.number;
        const isActive = currentStep === step.number;
        return (
          <div key={step.number} className="relative z-10 flex flex-col items-center gap-2">
            <div
              className={`w-10 h-10 flex items-center justify-center rounded-full border-2 transition-all duration-300 ${
                isDone
                  ? 'bg-emerald-600 border-emerald-600 text-white'
                  : isActive
                  ? 'bg-white border-emerald-600 text-emerald-600'
                  : 'bg-white border-stone-200 text-stone-400'
              }`}
            >
              {isDone ? (
                <i className="ri-check-line text-sm font-bold"></i>
              ) : (
                <i className={`${step.icon} text-sm`}></i>
              )}
            </div>
            <span
              className={`text-xs font-medium whitespace-nowrap hidden sm:block ${
                isActive ? 'text-emerald-600' : isDone ? 'text-stone-600' : 'text-stone-400'
              }`}
            >
              {step.label}
            </span>
          </div>
        );
      })}
    </div>
  </div>
);

export default StepIndicator;
